export default __webpack_public_path__ + "static/media/cartoon.7e9c0c2f.png";